import type { ComponentType } from 'react';
import ArcanatacticsHeroDetailTemplate from './arcanatactics-template';
import DefaultHeroDetailTemplate from './default-template';
import RellionHeroDetailTemplate from './rellion-template';
import type { HeroDetailTemplateProps } from './types';
import {
  catalogTemplateSettingsFromGame,
  customHeroTemplateGames,
} from '../../lib/catalog-template-config';

const templates: Record<string, ComponentType<HeroDetailTemplateProps>> = {
  arcanatactics: ArcanatacticsHeroDetailTemplate,
  rellion: RellionHeroDetailTemplate,
};

export function registerHeroDetailTemplate(
  gameKey: string,
  template: ComponentType<HeroDetailTemplateProps>,
) {
  templates[gameKey] = template;
}

export default function HeroDetailRenderer(props: HeroDetailTemplateProps) {
  const settings = catalogTemplateSettingsFromGame(props.game.settings);
  const templateSourceGame =
    settings.updatePolicy === 'custom'
      ? props.game.key
      : settings.templateSourceGame ||
        (settings.detailTemplate === 'custom' ? props.game.key : '');
  const customTemplate =
    templates[templateSourceGame] || templates[props.game.key];
  // 已注册专属模板的游戏（含 SPA 占位期 settings 未就绪）直接走专属模板，避免落到浅色 default
  const wantsCustom =
    settings.updatePolicy === 'custom' ||
    Boolean(settings.templateSourceGame) ||
    settings.detailTemplate === 'custom' ||
    customHeroTemplateGames.has(props.game.key) ||
    Boolean(templates[props.game.key]);
  if (settings.updatePolicy === 'custom' && !customTemplate) {
    return (
      <main className="hero-template-missing">
        当前游戏尚未生成专属图鉴模板，已停止使用公共模板以避免交叉影响。
      </main>
    );
  }
  const Template =
    wantsCustom && customTemplate ? customTemplate : DefaultHeroDetailTemplate;
  return <Template {...props} />;
}
